<script setup lang="ts">
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue';
import OutlinedBtn from '../ui-elements/buttons/OutlinedBtn.vue';

interface Props {
  title: string
  message: string
  actionName: string
  action: () => void
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const close = () => {
  // Emit an event to the parent component to close the error card
  // You can also handle any additional cleanup here if necessary
  emit('close')
}

</script>
<template>
  <v-card class="rounded-lg pa-10">
    <v-card-title class="d-flex flex-column align-center text-center font-weight-bold">
      <v-icon color="pwt_red" size="50">mdi-alert-octagon-outline</v-icon>
      <span>{{ title }} </span>
    </v-card-title>
    <v-card-text class="text-center">
      {{ message }}
    </v-card-text>
    <v-card-actions class="justify-center pt-5">
      <OutlinedBtn @click="close" class="mr-2" color="pwt_red"> Dismiss </OutlinedBtn>
      <ElevatedBtn @click="action" class="ml-2"> {{ actionName }} </ElevatedBtn>
    </v-card-actions>
  </v-card>
</template>
